import feathersClient, { makeServicePlugin, BaseModel } from '@/api-client'

class KitPart extends BaseModel {
  static modelName = 'KitPart'

  static instanceDefaults (data, { store, models }) {
    return {
      qty: 1
    }
  }
}
const servicePath = 'kit-parts'
const servicePlugin = makeServicePlugin({
  Model: KitPart,
  // IMPORTANT
  whitelist: ['$eager', '$iRegexp', '$regex', '$options', '$mergeEager'],
  service: feathersClient.service(servicePath),
  servicePath
})

// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
  before: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    remove: []
  },
  after: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  }
})

export default servicePlugin
